import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

import componentStyles from './pc-menu-link.css.lit';
import globalStyles from './pc-menu-link.lightDom.css.lit';

import '../pc-icon/pc-icon';

/**
 * Menu Link component
 * @element pc-menu-link
 * @slot - This element has a default slot
 */
@customElement('pc-menu-link')
export class PCMenuLink extends OutlineElement {
  adoptedStylesheets: AdoptedStyleSheets;
  static styles: CSSResultArray = [componentStyles];

  @property()
  variant: 'default' | 'title' = 'default';

  @property({ type: Number })
  level: Number;

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);

    const classes = ['menu-link', `menu-link--${this.variant}`];

    if (this.level) {
      classes.push(`menu-link--level-${this.level}`);
    }

    this?.querySelector('a')?.classList.add(...classes);
  }

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-menu-link': PCMenuLink;
  }
}
